 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ClientOpportunityFollowupAddEdit',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		// alert('load function called');
	};

	form.success = function success(response)
	{
		var $form_jqo         = $('form[name="' + form.name + '"]'),
			opportunity_id    = $form_jqo.data('opportunity-id'),
			url               = '/ClientOpportunityFollowups/ajaxReloadList/' + opportunity_id,
			hide_add_link     = 0,
			referer           = window.location.pathname,
			is_client_profile = referer.search("/Clients/salesOpportunities"),
			client_id         = 0;

		if (is_client_profile > -1) {
			client_id = referer.split("/").pop();
			url       = '/ClientOpportunityFollowups/ajaxReloadListForClient/' + client_id;
		}

		if ($('#followup_hide_add_link').length > 0) {
			hide_add_link = 1;
		}

		if (!Adzuki.Form.hasError(response)) {

			// reload followups table
			Adzuki.Ajax.get(url + '/0/' + hide_add_link)
			.then(function populate(content) {

				// success message
				Adzuki.StatusMessage('Success', 'Successfully saved follow-up');

				// replace follow-ups list
				$('#client_opportunity_follow_ups').replaceWith(content);

				// close right sidebar
				Adzuki.Sidebar.toggleRightSidebar('off');

				// it makes most sense to reload the archived follow ups too. It simplifies trying to figure out which section needs to be reloaded. For example,
				// a normal edit would just need the current section to be reloaded, but if you duplicate an archived follow-up, we treat it as a regular follow-up
				// and that requires the regular follow-up div to be reloaded
				Adzuki.Ajax.get(url + '/1/' + hide_add_link)
				.then(function populate(content) {

					// replace follow-ups list
					$('#archived_client_opportunity_follow_ups').replaceWith(content);
				});
			});
		}

		return false;
	};

	form.error = function error()
	{
		Adzuki.StatusMessage('Error', 'Error saving follow-up');
		return false;
	};

}(jQuery, window.Adzuki || {}));
